import { createApiAction } from '@saucelabs/sl-util-redux';
import { actions as notifications } from '@saucelabs/sl-container-notifications';

import * as api from './api';
import * as types from './types';

export const fetchAppStorageGroups = createApiAction(
  types.APP_STORAGE_FETCH_GROUPS,
  (payload, meta, dispatch) => (
    api.fetchAppGroups(payload)
      .catch((error) => {
        dispatch(notifications.notifyDanger(error));
        throw error;
      })
  ),
  { meta: { skipErrorPage: true } },
);
